export const getTitleCase = (str: string | null) =>
    str?.length ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : str;
